var tools = {};

tools.getHeadIdByUrl = function (url) {
    if (!url) {//"http://slots-static.bangbet.com/avatar_1.png"
        return 1;
    }

    var pattern = /avatar_(\S+)\./;
    var arr = pattern.exec(url);
    if (arr) {

        console.log(arr);
        return arr[1];
    }

    return 1;

}
tools.getHeadUrlById = function (id) {
    return `http://slots-static.bangbet.com/avatar/avatar_${id}.png`;

}
export default tools;


// WEBPACK FOOTER //
// ./src/utils/userFun.js